// extracted by mini-css-extract-plugin
export default {"para_history":"history_para_history__vNOYY","text_overlay":"history_text_overlay__JieC5","flex_item":"history_flex_item__3Iawx"};